import { cn } from '@creanizer/utils'

interface DocumentTypeSelectorProps {
  value: string
  onChange: (value: string) => void
}

const documentTypes = [
  { 
    value: 'newspaper', 
    label: '新聞記事', 
    icon: '📰',
    description: 'ニュース記事形式'
  },
  { 
    value: 'sns_twitter', 
    label: 'Twitter/X', 
    icon: '🐦',
    description: 'SNS投稿形式'
  },
  { 
    value: 'diary', 
    label: '日記', 
    icon: '📔',
    description: '個人的な日記'
  },
  { 
    value: 'report', 
    label: '報告書', 
    icon: '📋',
    description: '公式報告書'
  },
  { 
    value: 'blog', 
    label: 'ブログ', 
    icon: '💻',
    description: 'ブログ記事'
  },
  { 
    value: 'email', 
    label: 'メール', 
    icon: '✉️',
    description: '電子メール'
  },
  { 
    value: 'letter', 
    label: '手紙', 
    icon: '💌',
    description: '手紙・書簡'
  },
  { 
    value: 'memo', 
    label: 'メモ', 
    icon: '📝',
    description: 'メモ・覚書'
  },
  { 
    value: 'medical', 
    label: '医療記録', 
    icon: '🏥',
    description: 'カルテ・診断書'
  },
  { 
    value: 'police', 
    label: '警察調書', 
    icon: '👮',
    description: '捜査資料・調書'
  },
  { 
    value: 'academic', 
    label: '学術論文', 
    icon: '🎓',
    description: '研究論文・レポート'
  },
  { 
    value: 'government', 
    label: '公式文書', 
    icon: '🏛️',
    description: '政府・行政文書'
  },
  { 
    value: 'magazine', 
    label: '雑誌記事', 
    icon: '📖',
    description: '雑誌・専門誌記事'
  },
  { 
    value: 'line', 
    label: 'LINE', 
    icon: '💬',
    description: 'LINEチャット'
  },
  { 
    value: 'history', 
    label: '歴史文書', 
    icon: '📜',
    description: '歴史分析・考察'
  },
  { 
    value: 'custom', 
    label: 'カスタム', 
    icon: '✨',
    description: '自由形式'
  }
]

export function DocumentTypeSelector({ value, onChange }: DocumentTypeSelectorProps) {
  return (
    <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 gap-3">
      {documentTypes.map(type => (
        <button
          key={type.value}
          onClick={() => onChange(type.value)}
          className={cn(
            "p-4 border rounded-lg text-center transition-all hover:shadow-md",
            value === type.value 
              ? "border-blue-500 bg-blue-50 shadow-md" 
              : "border-gray-200 hover:border-gray-300 bg-white"
          )}
        >
          <div className="text-3xl mb-2">{type.icon}</div>
          <div className="font-medium text-sm">{type.label}</div>
          <div className="text-xs text-gray-500 mt-1">
            {type.description}
          </div>
        </button>
      ))}
    </div>
  )
}